/* =========================================================
   V_B2D_HP_63 | Comparison Section vs High Street — Homepage (winner: Var A)

   Live Trustpilot figures only. The section's settings values render first as
   a fallback; this swaps in the current review count, rating and stars from
   the data feed the TrustBox widgets themselves read (data-tp-url).
   ========================================================= */

(function () {
  function updateTrustpilot(root) {
    var url = root.getAttribute('data-tp-url');
    if (!url || !window.fetch) return;
    var locale = root.getAttribute('data-tp-locale') || undefined;

    fetch(url)
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) {
        var business = data && data.businessEntity;
        var total = business && business.numberOfReviews && business.numberOfReviews.total;
        var score = business && business.trustScore;
        if (typeof total !== 'number' || typeof score !== 'number') return;

        var count = total.toLocaleString(locale);
        var rating = score.toFixed(1);
        var stars = Math.round(score);

        var i, j, els;
        els = root.querySelectorAll('[data-c-hp63-tp="count"]');
        for (i = 0; i < els.length; i++) els[i].textContent = count;
        els = root.querySelectorAll('[data-c-hp63-tp="rating"]');
        for (i = 0; i < els.length; i++) els[i].textContent = rating;
        els = root.querySelectorAll('[data-c-hp63-tp="stars"]');
        for (i = 0; i < els.length; i++) {
          els[i].setAttribute('aria-label', rating + '/5');
          var imgs = els[i].querySelectorAll('img');
          for (j = 0; j < imgs.length; j++) imgs[j].hidden = j >= stars;
        }
      })
      .catch(function () {});
  }

  function init(root) {
    if (root.hasAttribute('data-c-hp63-ready')) return;
    root.setAttribute('data-c-hp63-ready', '');
    updateTrustpilot(root);
  }

  function start() {
    var roots = document.querySelectorAll('[data-c-hp63]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Theme editor: the section is re-rendered in place when settings change.
  document.addEventListener('shopify:section:load', start);
})();
